import { Category, MultiLayoutDetails } from './../device';
import { SingleLayoutDetails, ProductOption, TagDevice } from '../device';
import { PlanogramProductInfo } from '../shelfPlanogram';

export type Identifier = string;
export type SlugStyle = string;

export const enum ASSOCIATION_MODE {
    SINGLE = 'SINGLE',
    MULTI = 'MULTI',
}

export const enum PAIRING_MODE {
    SHELF = 'shelf',
    IMAGE = 'image',
}

export const enum ASSOCIATE_PAIRING_MODE {
    NORMAL = 'normal',
    IMAGE = 'image',
}
export const CAMPAIGN_LAYOUT_PURPOSE = 7;

export type LayoutWithCampaignInfo = {
    layout_purpose?: number;
    sub_layout_purpose?: number;
};

export type AssociateModeRelations = Record<string, string>;

export type AssociationMode = ASSOCIATION_MODE.SINGLE | ASSOCIATION_MODE.MULTI | null;
export type ProfileRelations = Record<Identifier, Profile>;

export type IdentifierInfo = {
    width: number;
    height: number;
    bpp: number;
};
export type PlanogramConfig = {
    enable: boolean;
    autoSelect: boolean;
    noOption: boolean;
};

export type Profile = {
    mac: string[];
    identifier: string;
    name: string;
    layouts: SingleLayoutDetails[];
    subLayouts: MultiLayoutDetails;
};

export type Dialogs = {
    defaultLayout: boolean;
    shelf: boolean;
    image: boolean;
    pairingMode: boolean;
    multiProfile: boolean;
};

export type AssociationDialogProps = {
    mode: AssociationMode;
    macs: string[];
    onClose: () => void;
    onUpdateSuccess: () => void;
};

export type MultiRelations = Record<Identifier, Record<SlugStyle, Record<string, string>>>;

export type ShelfInfo = {
    openFeature: boolean;
    options: PlanogramProductInfo[];
    shouldOpenDialog: boolean;
    relations: AssociateModeRelations;
};
export type ImageOptions = {
    id: string;
    name: string;
    barcode: string;
    slot: {
        id: number;
        previewUrl: string;
        img_height: number;
        img_width: number;
        img_name: string;
    }[];
};
export type ImageInfo = {
    openFeature: boolean;
    options: ImageOptions[];
    relations: AssociateModeRelations;
};

export type MultiCategoryRelations = Record<string, Category[]>;

export type MultiProducts = ProductOption | null;

type associationId = number | null;
export type LayoutIdRelations = Record<Identifier, associationId>;

export type MultiAssociationTemp = {
    isFinish: boolean;
    products: MultiProducts[];
    layoutId: associationId;
    skeletonId: associationId;
    shelfIdRelations: AssociateModeRelations;
    imageRelations: AssociateModeRelations;
};
export type MultiTempRelations = Record<Identifier, MultiAssociationTemp>;
export type SingleAssociateTemp = {
    isFinish: boolean;
    product: ProductOption | null;
    layoutIdRelations: LayoutIdRelations;
};

export type MultiAssociate = {
    styleOptions: Category[];
    styleInfo: Category;
};

export type AssociationState = {
    loading: boolean;
    associateLoading: boolean;
    profiles: ProfileRelations;
    category: MultiCategoryRelations;
    productLoading: boolean;
    noCampaignWording: string;
    currentProfile: Profile | null;
    campaignEnable: boolean;
    planogramConfig: PlanogramConfig;
    dialogs: Dialogs;
    shelfInfo: ShelfInfo;
    imageInfo: ImageInfo;
    selectedPairingMode: ASSOCIATE_PAIRING_MODE;
    multi: MultiAssociate;
    multiAssociateTemp: MultiTempRelations;
    singleAssociateTemp: SingleAssociateTemp;
};

export type AssociationPayload = {
    macs: string[];
    products: string[];
    overwrite_layout: string | number;
    multi_layout_skeleton_id: number | null;
    overwrite_shelf_codes: associationId[] | null;
    overwrite_campaign_id: associationId[] | null;
};

export type AssociateAction =
    | { type: 'SET_LOADING'; payload: boolean }
    | { type: 'SET_ASSOCIATE_LOADING'; payload: boolean }
    | { type: 'SET_PRODUCT_LOADING'; payload: boolean }
    | { type: 'SET_NO_CAMPAIGN_WORDING'; payload: string }
    | { type: 'SET_DIALOG'; payload: { key: keyof Dialogs; open: boolean } }
    | { type: 'SET_INIT'; payload: { device: TagDevice[]; category: MultiCategoryRelations } }
    | { type: 'SET_CURRENT_PROFILE'; payload: Profile | null }
    | { type: 'SET_SHELF_INFO'; payload: Partial<ShelfInfo> }
    | { type: 'SET_IMAGE_INFO'; payload: Partial<ImageInfo> }
    | { type: 'SET_SELECTED_PAIRING_MODE'; payload: ASSOCIATE_PAIRING_MODE }
    | { type: 'SET_MULTI_PAIRING_MODE'; payload: ASSOCIATE_PAIRING_MODE }
    | { type: 'SET_SINGLE_PRODUCT'; payload: ProductOption | null }
    | { type: 'CLEAR_SINGLE_LAYOUT_RELATIONS' }
    | { type: 'SET_MULTI_CURRENT_PROFILE'; payload: Profile }
    | {
          type: 'SET_SINGLE_LAYOUT_RELATIONS';
          payload: {
              key: Identifier;
              layoutId: number | null;
          };
      }
    | { type: 'SET_MULTI_STYLE'; payload: Category }
    | { type: 'SET_MULTI_PRODUCT'; payload: { product: ProductOption | null; index: number } }
    | { type: 'SET_MULTI_LAYOUT_RELATIONS'; payload: number | null }
    | { type: 'SET_MULTI_SHELF_RELATIONS'; payload: AssociateModeRelations }
    | { type: 'SET_MULTI_IMAGE_RELATIONS'; payload: AssociateModeRelations }
    | { type: 'SET_MULTI_PROFILE_FINISH' }
    | { type: 'CLEAR_MULTI' }
    | { type: 'SET_CLEAR' };
